<template>
  <div class="Mybody">
    <div style="background-color: white; margin-top: -70px">
      <!--header-->
      <div class="container-fluid" style="width: 1170px">
        <div style="float: left">
          <img
            src="../assets/imgs/png/logo-dashboard.jpg"
            height="90px"
            style="margin-top: 5px"
          />
        </div>
        <!--Logo-->
        <div style="margin-top: 20px; float: right !important">
          <a
            href="javascript:void(0);"
            @click="getLinks('masters')"
            v-if="RoleId == 1 || RoleId == 2 || RoleId == 5"
          >
            <img
              v-if="Active == 'masters'"
              src="../assets/imgs/png/Masterselected.png"
            />
            <img v-else src="../assets/imgs/png/Master.png" />
            <img src="../assets/imgs/png/line.png" />
          </a>
          <a
            href="javascript:void(0);"
            @click="getLinks('requests')"
            v-if="
              RoleId == 2 ||
              RoleId == 1 ||
              RoleId == 3 ||
              RoleId == 4 ||
              RoleId == 5
            "
          >
            <img
              v-if="Active == 'requests'"
              src="../assets/imgs/png/Approvalsselected.png"
            />
            <img v-else src="../assets/imgs/png/Approvals.png" />
            <img src="../assets/imgs/png/line.png" />
          </a>

          <!-- <a href="javascript:void(0);" @click="Active='approvals';getLinks('approvals');">
            <img
              v-if="!(Bank && Bank.roleid==Roles.BankAdmin) && Active=='approvals'"
              src="../assets/imgs/png/Approvals-selected.png"
            >
            <img
              v-else-if="!( Bank && Bank.roleid==Roles.BankAdmin)"
              src="../assets/imgs/png/Approvals.png"
            >

            <img src="../assets/imgs/png/line.png">
          </a>-->

          <a
            href="javascript:void(0)"
            @click="getLinks('mis')"
            v-if="
              RoleId == 1 ||
              RoleId == 2 ||
              RoleId == 4 ||
              RoleId == 3 ||
              RoleId == 5
            "
          >
            <img
              v-if="Active == 'mis'"
              src="../assets/imgs/png/MISselected.png"
            />

            <img v-else src="../assets/imgs/png/MIS.png" />
            <img src="../assets/imgs/png/line.png" />
          </a>

          <a
            href="javascript:void(0)"
            @click="getLinks('uploadprice')"
            v-if="RoleId == 1"
          >
            <img
              v-if="Active == 'uploadprice'"
              src="../assets/imgs/png/UploadPricesselected.png"
            />
            <img v-else src="../assets/imgs/png/UploadPrices.png" />
            <img src="../assets/imgs/png/line.png" />
          </a>
          <!-- 
          <a href="javascript:void(0);" @click="getLinks('commission')" v-if="RoleId==1">
            <img v-if="Active=='commissions'" src="../assets/imgs/png/CommissionS1.png">
            <img v-else src="../assets/imgs/png/Commissions.png">
          </a>-->
        </div>
      </div>
    </div>

    <div class="row subhead">
      <div class="container-fluid" style="margin-top: 20px">
        <div class="col-md-8">
          <a
            v-for="(option, index) in GetAccessLinks"
            v-bind:class="{ sel: linkActive == option.id }"
            v-bind:id="
              option.StyleID != null ? option.StyleID : '47se125A' + index
            "
            @click="ChangeActiveLink(option.id, option.load)"
            :key="index"
            >{{ option.name }}</a
          >
        </div>
        <div class="col-md-4 notification">
          <div class="row">
            <div class="col-md-3" style="margin-left: -30px">
              <a href="#">
                <img
                  src="../assets/imgs/png/Notification.png"
                  style="margin: 0; padding: 0"
                />
              </a>
              <img
                src="../assets/imgs/png/lineSs.png"
                style="height: 30px; margin-left: 7px"
              />
            </div>
            <div class="col-md-6">
              <div class="row">
                <div
                  class="col-md-4"
                  style="margin-top: -5px; margin-left: -20px; height: 50px"
                >
                  <span class="welcome">Welcome</span>
                  <span class="user">
                    <br />
                    {{ name }}
                  </span>
                </div>
                <div class="col-md-8" style="margin-left: 10px">
                  <a href="javascript:void(0);" @click="logOut">
                    <input type="button" class="logout-button" value="LOGOUT" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <router-view />
    </div>

    <!-- <span>{{Bank}}</span>
    <span>{{RoleId}}</span>
    <span>{{Roles}}</span>
    Branch: 'Branch',
    <span>{{Branch}}</span>-->
  </div>
</template>
 
<script>
//import "../assets/css/bootstrap.min.css";
import * as ACTIONS from "../store/actions";
import { mapGetters, mapState } from "vuex";

export default {
  name: "defaultLayout",
  // you can enter any name (optional)
  data() {
    return {
      Active: "requests",
      Links: null,
      showCommissions: false,
      linkActive: "",
      Links: [],
      Menu: {
        requests: [
          {
            id: "Request",
            name: "PURCHASE ",
            load: "/Requests",
            StyleID: "BuyRequest",
          },
          {
            id: "sellRequest",
            name: "SELL",
            load: "/SellRequest",
            StyleID: "SellRequest",
          },
          {
            id: "Completed",
            name: "COMPLETED ",
            load: "/CompletedRequest",
            StyleID: "CompletedRequest",
          },
        ],
        masters: [
          { id: "Users", name: "USER", load: "/Users", Roles: ["1", "2", "5"] },
          {
            id: "Vendors",
            name: "VENDORS",
            load: "/vendor/vendors",
            Roles: ["1"],
          },
          {
            id: "Commodity",
            name: "COMMODITIES",
            load: "/Commodities",
            Roles: ["1"],
          },
          {
            id: "bankCommodities",
            name: "BANK COMMODITIES",
            load: "/BankCommodities",
            Roles: ["1"],
          },
        ],
        mis: [{ id: "mis", name: "MIS", load: "/MIS" }],
        uploadprice: [
          { id: "UploadPrice", name: "UPLOAD PRICES", load: "/UplaodPrices" },
        ],
        // commission: [
        //   { id: "commision", name: " COMMISION", load: "/Commitions" }
        // ]
      },
    };
  },
  components: {
    //  / commissions
  },
  methods: {
    closeModal() {
      this.showCommissions = false;
    },
    ChangeActiveLink(id, link) {
      this.linkActive = id;
      this.$router.push({ path: link });
    },

    logOut: function () {
      var vm = this;
      this.$store
        .dispatch(ACTIONS.LOGOUT_REQUEST)
        .then((res) => {
          vm.$router.push("/login");
        })
        .catch((err) => {
          vm.$router.push("/login");
        });
    },
    getLinks(key) {
      if (key != this.Active) {
        this.Active = key;
        var Links = this.Menu[key];
        if (Links) {
          var firstLink = Links[0];
          this.linkActive = Links[0].id;
          this.Links = this.Menu[key];
          this.$router.push(firstLink.load);
        }
      }
    },
  },
  beforeMount() {
    if (this.$route.meta && this.$route.meta.redirect) {
      this.Active = this.$route.meta.link;
      this.Links = this.Menu[this.$route.meta.link];
      this.linkActive = this.$route.meta.id;
      this.$router.push(this.$route.meta.redirect);
    } else {
      if (this.$route.meta && this.$route.meta.link) {
        this.Active = this.$route.meta.link;
        this.Links = this.Menu[this.$route.meta.link];
        this.linkActive = this.$route.meta.id;
      }
    }

    //change style for body element
    if (this.$route.meta && this.$route.meta.class) {
      document.body.className = this.$route.meta.class;
      document.body.id = this.$route.meta.class;
    } else {
      document.body.className = "";
    }
  },
  computed: {
    GetAccessLinks() {
      var links = [];
      if (this.Active == "masters") {
        for (var i = 0; i < this.Links.length; i++) {
          var roles = this.Links[i].Roles;
          if (
            roles &&
            this.RoleId &&
            roles.indexOf(this.RoleId.toString()) > -1
          ) {
            links.push(this.Links[i]);
          }
        }
      } else {
        links = this.Links;
      }
      return links;
    },
    ...mapGetters({
      name: "name",
      RoleId: "RoleId",
      // Bank: "Bank",
      // Branch: "Branch",
      //hideBranch: "hideBranch",
      // BankUserRoles: "BankUserRoles",
      Roles: "Roles",
      isAuth: "authencticate",
    }),
  },
};
</script>
 
<style>
/* your style */

body {
  width: "100%";
  font-family: "Helvetica Neue,Helvetica,Arial", sans-serif;
  font-size: 16px;
}
.search-box {
  height: 34px !important;
  padding: 0px !important;
  padding-left: 10px !important;
}
</style>